import React from 'react';
import { IsLoggedInUserViewer } from "../../../hoc/withAuthRedirect";

const ButtonGroup = ({ buttons, justifyContent }) => {
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: justifyContent ? justifyContent : "space-between",
    alignItems: "center",
    margin: "10px 0",
    whiteSpace: "nowrap",
  };

  return (
    
    <div style={buttonContainerStyle}>
      {buttons.map((button, index) => {
        if (button.action === "create" && IsLoggedInUserViewer() && button.table!=="userrole")
          return null;
        const buttonStyle = {
          padding: "4px 8px",
          border: button.disabled ? `1px solid grey` : `1px solid ${button.buttonColor}`,
          backgroundColor: button.disabled ? "grey" : button.buttonType === "filled" ? button.buttonColor : "transparent",
          color: button.disabled ? "white" : button.textColor,
          borderRadius: button.borderRadius ? button.borderRadius : "2px",
          cursor: "pointer",
          fontSize: "15px",
          margin: button.margin ? button.margin : "5px",
          height: "35px",
          width: button.width ? button.width : "auto",
          boxShadow: button.boxShadow ? button.boxShadow : "transparent",
        };

        return (
          <button key={index} style={buttonStyle} disabled={button.disabled} onClick={button.onClick}>
            {button.buttonText}
          </button>
        );
      })}
    </div>
  );
};

export default ButtonGroup;
